import React, {useContext} from "react"
import Grid from '@mui/material/Grid';
import OutlinedInput from '@mui/material/OutlinedInput';
import {Box, Button, Typography} from "@mui/material";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {useHistory} from "react-router";
import {RoleContext} from "../../hoc/role";
import {SUPER_ADMIN} from "../../constants";
import {MessageContext} from "../../hoc/messageNotification";
import {LoadingContext} from "../../hoc/loading";
import { remove } from "@api/segment"

const useStyles = makeStyles({
    main: {
        marginTop: '2em',
    },
    title: {
        fontSize: '24px',
        fontWeight: 'bold',
    },
    label: {
        fontSize: '16px',
        fontWeight: 'bold',
    },
    segment: {
        marginTop: '0.1em',
    },
});

export const Item = ({name, id, onRemoveSegment, data}) => {
    const classes = useStyles();
    const history = useHistory();
    const {role} = useContext(RoleContext);
    const {setLoading} = useContext(LoadingContext);
    const {setErrorMessage} = useContext(MessageContext);

    const onEdit = () => {
        history.push('/edit-segment/' + id)
    }

    const onRemove = async () => {
        try {
            setLoading(true);
            setErrorMessage(null);

            onRemoveSegment(id)
            await remove(id)
            history.push(`/segment`)
        } catch (e) {
            setErrorMessage(e);
        }
        setLoading(false);
    }

    return (
        <Grid className={classes.main} container spacing={0.5}>
            <Grid item xs={6} md={2}>
                <Box display={"flex"} justifyContent={"space-between"}>
                    <Typography className={classes.label} component="h4">{name}</Typography>
                </Box>
            </Grid>
            <Grid item xs={6} md={2}>
                <Box display={"flex"} justifyContent={"end"}>
                    {role === SUPER_ADMIN && <Button variant="text" color="error" onClick={onRemove}>Remove</Button>}
                    <Button variant="text" onClick={onEdit}>Edit</Button>
                </Box>
            </Grid>
            <Grid item xs={0} md={4}>
            </Grid>
            {data.map(({name}, ind) => (
                <Grid container spacing={2} className={classes.segment} key={ind}>
                    <Grid item xs={12} md={4}>
                        <OutlinedInput
                            disabled
                            value={name}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={0} md={8}>
                    </Grid>
                </Grid>
            ))}
        </Grid>
    )
}